import React from 'react';

const IntroViguetaWpc = () => {
  return (
    <section className="bg-light">
      <div className="container mt-lg-3 mt-xl-0">
        <div className="row clearfix align-items-xl-center">
          <div className="col-lg-6 mb-2-9 mb-lg-0 position-relative wow fadeIn" data-wow-delay="400ms">
            <div className="position-relative">
              <div className="text-center text-sm-end text-md-center text-lg-end pe-xxl-1-9 overflow-hidden position-relative">
                <img 
                  src="/assets/img/productos/vigueta-wpc/vigueta-wpc-intro-a.jpg" 
                  alt="vigueta wpc" 
                  className="rounded" 
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 text-column">
            <div className="ps-lg-2-3">
              <div className="title-style2 mb-1-6 wow fadeInUp" data-wow-delay="200ms">
                <h2 className="h1">Vigueta WPC: Innovación y Estilo para Proyectos Duraderos</h2>
              </div>
              <p className="mb-2-2 wow fadeInUp" data-wow-delay="200ms">
              La vigueta WPC (Wood Plastic Composite) es la solución ideal para arquitectos y diseñadores que buscan combinar la calidez de la madera con la 
              durabilidad de los materiales modernos. Este producto, fabricado con una mezcla de madera reciclada y polímeros, ofrece una alternativa ecológica, 
              funcional y estéticamente atractiva para una amplia variedad de proyectos arquitectónicos.
              </p>
              <div className="border-top border-bottom py-4 mb-2-3 wow fadeInUp" data-wow-delay="300ms">
                <div className="row gx-5">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src="/assets/img/icons/01.png" alt="Altamente flexible" />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h4 className="mb-0 h5">Disponibilidad</h4>
                        <p>Entrega oportuna para cumplir con los plazos de tus proyectos.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src="/assets/img/icons/02.png" alt="Antideslizante" />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h4 className="mb-0 h5">Diseño estético</h4>
                        <p>Ideal para aplicaciones interiores como vigas.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-dark ps-2-3 pe-10 py-1-9 position-relative border-radius-10 wow fadeInUp" data-wow-delay="200ms">
                <p className="mb-0 lead font-weight-500 position-relative z-index-9 text-white">
                Combina la belleza de la madera con las ventajas de la tecnología moderna.
                </p>
                <img 
                  src="/assets/img/content/quote-right.png" 
                  className="position-absolute top-0 right" 
                  alt="icono" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-inline-block bg-secondary p-3 ani-zoomin rounded-circle position-absolute top-8 right-5 z-index-1 opacity1"></div>
    </section>
  );
};

export default IntroViguetaWpc;